import script from "./SignInNotificationsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInNotificationsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignInNotificationsPage.vue?vue&type=style&index=0&id=873acfb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-873acfb2"]])

export default __exports__